import { createReducer, on } from '@ngrx/store';
import * as authActions from '../auth/auth.actions';
import * as complicationNameSearchActions from './complication-name-search.actions';

export interface State {
	queryTerm: string;
	newSearchInProgress: boolean;
	searchResults: string[];
	resultsPerAppend: number;
	appendsRetrieved: number;
	lastResultsRetrievedCount: number;
}

export const initialState: State = {
	queryTerm: '',
	newSearchInProgress: false,
	searchResults: [],
	resultsPerAppend: 50, // this is a constant value, change this if more results should be displayed per fetch. Be careful setting it too low, if one page doesn't fill the scrollable parent, the infinite scroll will not fire
	appendsRetrieved: 0,
	lastResultsRetrievedCount: 0
}

export const complicationNameSearchReducer = createReducer(
	initialState,
	on(complicationNameSearchActions.newSearchRequested, (state, { queryTerm }) => ({
		...state,
		queryTerm: queryTerm,
		newSearchInProgress: true,
		searchResults: [],
		appendsRetrieved: 0,
		lastResultsRetrievedCount: 0
	})),
	on(complicationNameSearchActions.newSearchSucceeded, (state, { searchResults }) => ({
		...state,
		newSearchInProgress: false,
		searchResults: searchResults,
		lastResultsRetrievedCount: searchResults.length
	})),
	on(complicationNameSearchActions.newSearchFailed, () => initialState),
	on(complicationNameSearchActions.appendResultsSucceeded, (state, { searchResults }) => ({
		...state,
		searchResults: [...state.searchResults, ...searchResults],
		appendsRetrieved: state.appendsRetrieved + 1,
		lastResultsRetrievedCount: searchResults.length
	})),
	on(complicationNameSearchActions.appendResultsFailed, () => initialState),
	on(complicationNameSearchActions.resultsCleared, () => initialState),
	on(complicationNameSearchActions.selectionFinished, () => initialState),
	on(authActions.clearStateRequested, () => initialState)
);